import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
} from "@chakra-ui/react";
import React from "react";

const SurveyAlert = ({
  isOpen,
  onClose,
  confirmHandler,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  confirmHandler: () => void;
  isLoading: boolean;
}): JSX.Element => {
  const cancelRef = React.useRef<any | null>();

  /*  useEffect(() => {
    if (cancelRef?.current as boolean)
      cancelRef.current.onClick = () => onClose();
  }, [cancelRef?.current]); */

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={() => undefined}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader>Save Changes?</AlertDialogHeader>

        <AlertDialogBody>
          Are you sure you want to save all of your survey data and exit?
        </AlertDialogBody>
        <AlertDialogFooter>
          <Flex gap={3}>
            <Button
              colorScheme="teal"
              ml={3}
              onClick={confirmHandler}
              isLoading={isLoading}
              px={6}
            >
              Yes
            </Button>
            <Button ref={cancelRef} onClick={onClose} px={6}>
              No
            </Button>
          </Flex>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SurveyAlert;
